import {
  IGetAllMaterialRequirementRequest,
  IGetMaterialRequirementBookedPalletsRequest,
  IGetMaterialRequirementSuggestPalletsRequest,
  IImportMaterialRequirementRequest,
  IMaterialRequirementCreateSuggestPalletRequest,
  IUpdateMaterialRequirementRequest,
} from "model";
import { PREFIX } from "utils/Const";
import { BaseApiService } from "./BaseApiService";

export const prefix = PREFIX.materialRequirement;

const getUrl = (url: string) => {
  return `${prefix}/${url}`;
};
const URL_IMPORT_MATERIAL_REQUIREMENT = getUrl("import-request-material");
const URL_IMPORT_MOVE_MATERIAL = getUrl("import-move-material");
const URL_IMPORT_MOVE_BAG = getUrl("import-move-material-packaging");

const URL_UPDATE_MATERIAL_REQUIREMENT = getUrl("update-request-material");
const URL_GET_ALL_MATERIAL_REQUIREMENT = getUrl("get-material-request");
const URL_GET_MATERIAL_REQUIREMENT_BY_ID = getUrl(
  "get-material-request-detail"
);
const URL_GET_SUGGEST_PALLETS_MATERIAL_REQUIREMENT = getUrl(
  "get-material-request-suggest-pallet"
);
const URL_GET_BOOKED_PALLETS_MATERIAL_REQUIREMENT = getUrl(
  "get-material-request-booked-pallet"
);
const URL_INSERT_SUGGEST_PALLET_MATERIAL_REQUIREMENT = getUrl(
  "request-material-suggest-pallet-insert"
);

class MaterialRequirementApiService extends BaseApiService {
  public importMaterialRequirement = (
    request: IImportMaterialRequirementRequest
  ) =>
    this.postForm<IImportMaterialRequirementRequest, any>(
      URL_IMPORT_MATERIAL_REQUIREMENT,
      request
    );
  public importMoveMaterial = (request: IImportMaterialRequirementRequest) =>
    this.postForm<IImportMaterialRequirementRequest, any>(
      URL_IMPORT_MOVE_MATERIAL,
      request
    );
  public importMoveBag = (request: IImportMaterialRequirementRequest) =>
    this.postForm<IImportMaterialRequirementRequest, any>(
      URL_IMPORT_MOVE_BAG,
      request
    );
  public updateMaterialRequirement = (
    request: IUpdateMaterialRequirementRequest
  ) =>
    this.post<IUpdateMaterialRequirementRequest, any>(
      URL_UPDATE_MATERIAL_REQUIREMENT,
      request
    );
  public getAllMaterialRequirement = (
    request: IGetAllMaterialRequirementRequest
  ) => this.get<any>(URL_GET_ALL_MATERIAL_REQUIREMENT, { params: request });

  public getMaterialRequirementDetailById = (
    request: IGetAllMaterialRequirementRequest
  ) => this.get<any>(URL_GET_MATERIAL_REQUIREMENT_BY_ID, { params: request });

  public getMaterialRequirementSuggestPallets = (
    request: IGetMaterialRequirementSuggestPalletsRequest
  ) =>
    this.get<any>(URL_GET_SUGGEST_PALLETS_MATERIAL_REQUIREMENT, {
      params: request,
    });

  public getMaterialRequirementBookedPallets = (
    request: IGetMaterialRequirementBookedPalletsRequest
  ) =>
    this.get<any>(URL_GET_BOOKED_PALLETS_MATERIAL_REQUIREMENT, {
      params: request,
    });

  public createSuggestPalletMaterialRequirement = (
    request: IMaterialRequirementCreateSuggestPalletRequest
  ) => this.post<any>(URL_INSERT_SUGGEST_PALLET_MATERIAL_REQUIREMENT, request);
}

export default new MaterialRequirementApiService();
